<template>
  <div class="page">
    <div class="table-wrap">
      <table class="table spacing-table discount-table">
        <tr>
          <th></th>
          <th v-for="(day, index) in dayList" :key="day.stageRuleId">
            <template v-if="index === 0">{{ $t('common.within', [`${day.value} ${$t('common.day', ['s'])}`]) }}</template>
            <template v-if="index > 0 && index < dayList.length - 1">{{ day.value }} {{ $t('common.day', ['s']) }}</template>
            <template v-if="dayList.length > 1 && index === dayList.length - 1">{{
              $t('common.moreThan', [`${day.value} ${$t('common.day', ['s'])}`])
            }}</template>
          </th>
        </tr>
        <template v-if="tableData.length > 0">
          <tr v-for="(type, typeIndex) in typeList" :key="type.typeId">
            <td>{{ type.typeName }}</td>
            <td v-for="(day, dayIndex) in dayList" :key="`${typeIndex}-${dayIndex}`">
              <el-input v-model="tableData[typeIndex][dayIndex].discount" size="small" @input="(val) => inputNum(val, typeIndex, dayIndex)">
                <i slot="suffix" class="el-input__icon">%</i>
              </el-input>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <el-button class="mt10" type="primary" @click="submit">{{ $t('common.save') }}</el-button>
  </div>
</template>

<script>
import {
  getRuleDiscountTypeList, getDiscountDaysList, getRuleDiscountList, saveRuleDiscountOnSupplyPrice,
} from '../../api/product';

export default {
  name: 'ProductSupplyPriceImport',
  data() {
    return {
      loading: false,
      typeList: [],
      dayList: [],
      tableData: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getRuleDiscountTypeList().then((res) => {
        if (res.success && res.data) {
          this.typeList = res.data;
          this.typeLoaded = true;
          this.initTable();
        }
      });
      getDiscountDaysList().then((res) => {
        if (res.success && res.data) {
          this.dayList = res.data;
          this.dayLoaded = true;
          this.initTable();
        }
      });
      getRuleDiscountList().then((res) => {
        if (res.success && res.data) {
          this.originData = res.data;
          this.originDataLoaded = true;
          this.initTable();
        }
      });
    },
    initTable() {
      if (this.typeLoaded && this.dayLoaded && this.originDataLoaded) {
        const list = [];
        this.typeList.forEach((type) => {
          const rows = [];
          this.dayList.forEach((day) => {
            let col = null;
            this.originData.some((item, index) => {
              if (item.stageRuleId === day.stageRuleId && item.typeId === type.typeId) {
                col = item;
                this.originData.splice(index, 1);
                return true;
              }
              return false;
            });
            if (col) {
              rows.push({
                id: col.id,
                stageRuleId: col.stageRuleId,
                typeId: col.typeId,
                discount: col.discount,
              });
            } else {
              rows.push({
                // id: col.id,
                stageRuleId: day.stageRuleId,
                typeId: type.typeId,
                discount: null,
              });
            }
          });
          list.push(rows);
        });
        this.tableData = list;
      }
    },
    inputNum(val, typeIndex, dayIndex) {
      // 替换掉数字和小数点 . 之外的字符
      val = val.replace(/[^\d.]/g, '');
      // 把2个以上的小数点 . 替换成一个小数点 .
      val = val.replace(/\.{2,}/g, '.');
      // 保证第一个字符为数字而不是小数点 .
      val = val.replace(/^\./g, '');
      // 保证小数点 . 只出现一次，而不能出现两次以上
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      // 只能输入两个小数
      val = val.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      this.tableData[typeIndex][dayIndex].discount = val;
    },
    submit() {
      const data = this.tableData.flat(2);
      if (data.some((item) => item.discount === null || item.discount === '')) {
        this.$message(this.$t('common.pleasecompletetheinformation'));
        return;
      }
      saveRuleDiscountOnSupplyPrice(data).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('error.successful'));
          this.typeLoaded = false;
          this.dayLoaded = false;
          this.originDataLoaded = false;
          this.init();
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-wrap {
  overflow: auto;
}
.discount-table {
  width: auto;
  th {
    min-width: 100px;
  }
}
</style>
